// select2 UMD's CJS branch exports a wrapper function —
// `module.exports = function(root, jQuery){ factory(jQuery); ... }` — which
// does NOT auto-execute the factory. Under webpack with ProvidePlugin the
// globals branch ran instead. With Vite we have to invoke the wrapper
// manually so `$.fn.select2` (and `$.fn.select2.amd`, which the i18n files
// look for at module-init time) gets set up.
//
// Static imports are hoisted, so we cannot do `import 'select2.full'` and
// `import 'select2/i18n/en'` in the same file — en.js would run before our
// factory call. Dynamic imports for the i18n files run after this module's
// body executes, by which point select2 is fully initialized.
import select2 from 'select2/dist/js/select2.full';
import 'select2/dist/css/select2.css';

if (typeof select2 === 'function') {
    select2(window, window.jQuery);
}

import('select2/dist/js/i18n/en');
import('select2/dist/js/i18n/hu');
